import React from 'react'
import Navbar from '../Ui/Navbar'
import { Outlet } from 'react-router-dom'
import Footer from '../Ui/Footer'

const NavFoot = () => {
  return (
    <div>
          <div>
    <div className="">
      <Navbar/>
    </div>
    <div className="">
      <Outlet  />
    </div>
    <div className="">
      
      <Footer/>
    </div>
  </div>
    </div>
  )
}

export default NavFoot